import React from 'react';
import {AdminPageHeader} from '../ui/AdminPageHeader';
import {AdminContentCard} from '../ui/AdminContentCard';
import '../ui/adminUi.css';
import { useTranslation } from 'react-i18next';

const ENDPOINTS_USED = [
    {method: 'POST', path: '/api/autenticacion/iniciar_sesion'},
    {method: 'POST', path: '/api/autenticacion/usuarios'},
    {method: 'GET', path: '/api/Usuario'},
    {method: 'GET', path: '/api/Usuario/:id'},
    {method: 'POST', path: '/api/Usuario'},
    {method: 'PUT', path: '/api/Usuario/:id'},
    {method: 'DELETE', path: '/api/Usuario/:id'},
    {method: 'GET', path: '/api/proyectos'},
    {method: 'GET', path: '/api/proyectos/resumen'},
    {method: 'GET', path: '/api/proyectos/:id'},
    {method: 'GET', path: '/api/proyectos/:id/version?version=:version'},
    {method: 'POST', path: '/api/proyectos'},
    {method: 'PUT', path: '/api/proyectos/:id'},
    {method: 'DELETE', path: '/api/proyectos/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Subcontratistas'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Subcontratistas'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Subcontratistas/:id'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Subcontratistas/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Reuniones'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Reuniones'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Reuniones/:id'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Reuniones/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Requerimientos'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Requerimientos'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Requerimientos/:id'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Requerimientos/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Plazos_Y_Justificacion'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Plazos_Y_Justificacion'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Plazos_Y_Justificacion/:id'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Plazos_Y_Justificacion/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Participacion_Ciudadana'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Participacion_Ciudadana'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Participacion_Ciudadana/:id'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Participacion_Ciudadana/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Informes_De_Gestion'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Informes_De_Gestion'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Informes_De_Gestion/:id'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Informes_De_Gestion/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Informacion_General'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Informacion_General'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Informacion_General/:id'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Informacion_General/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Hitos_Y_Objetivos'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Hitos_Y_Objetivos'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Hitos_Y_Objetivos/:id'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Hitos_Y_Objetivos/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Comunicacion'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Comunicacion'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Comunicacion/:id'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Comunicacion/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Autorizaciones_Solicitadas'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Autorizaciones_Solicitadas'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Autorizaciones_Solicitadas/:id'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Autorizaciones_Solicitadas/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Seguimiento_Coffe'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Seguimiento_Coffe'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Seguimiento_Coffe'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Seguimiento_Coffe/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Seguimiento_Plataforma'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Seguimiento_Plataforma'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Seguimiento_Plataforma'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Seguimiento_Plataforma/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Gastos_Imputados'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Gastos_Imputados'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Gastos_Imputados/:id'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Gastos_Imputados/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Datos_Contratos_P'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Datos_Contratos_P'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Datos_Contratos_P/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Datos_Contables'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Datos_Contables'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Datos_Contables/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Contratos_Mayores'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Contratos_Mayores'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Contratos_Mayores/:id'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Contratos_Mayores/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Contratos_Menores'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Contratos_Menores'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Contratos_Menores/:id'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Contratos_Menores/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Certificaciones_De_Obra'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Certificaciones_De_Obra'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Certificaciones_De_Obra'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Certificaciones_De_Obra'},
    {method: 'GET', path: '/api/subcontratistas/:idSub/documentacion'},
    {method: 'GET', path: '/api/subcontratistas/:idSub/documentacion/:id'},
    {method: 'POST', path: '/api/subcontratistas/:idSub/documentacion'},
    {method: 'PUT', path: '/api/subcontratistas/:idSub/documentacion/:id'},
    {method: 'DELETE', path: '/api/subcontratistas/:idSub/documentacion/:id'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/documentos'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/documentos'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/documentos/:id/contenido'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/documentos/:id'},
    {method: 'GET', path: '/api/adjudicatarios/contrato-mayor/:idContrato'},
    {method: 'GET', path: '/api/adjudicatarios/contrato-menor/:idContrato'},
    {method: 'POST', path: '/api/adjudicatarios/contrato-mayor/:idContrato'},
    {method: 'POST', path: '/api/adjudicatarios/contrato-menor/:idContrato'},
    {method: 'PUT', path: '/api/adjudicatarios/:id'},
    {method: 'DELETE', path: '/api/adjudicatarios/:id'},
    {method: 'GET', path: '/api/adjudicatarios/:idAdj/documentacion'},
    {method: 'POST', path: '/api/adjudicatarios/:idAdj/documentacion'},
    {method: 'PUT', path: '/api/adjudicatarios/:idAdj/documentacion/:id'},
    {method: 'DELETE', path: '/api/adjudicatarios/:idAdj/documentacion/:id'},
    {method: 'POST', path: '/api/proyectos/:idProyecto/Bloqueo/:usuarioId'},
    {method: 'PUT', path: '/api/proyectos/:idProyecto/Bloqueo/:usuarioId'},
    {method: 'DELETE', path: '/api/proyectos/:idProyecto/Bloqueo/:usuarioId'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Bloqueo'},
    {method: 'GET', path: '/api/proyectos/:idProyecto/Bloqueo/detalle'},
    {method: 'GET', path: '/api/publicos/proyectos/:idProyecto/Datos_Contratos_Pu'},
];

export function AdminEndpointsPage() {
    const { t } = useTranslation();
    return (
        <div className="adminPageWrap">
            <AdminPageHeader
                eyebrow={t('adminEndpointsPage.internalDocs')}
                title={t('adminEndpointsPage.endpointsAndLimitations')}
                description={t('adminEndpointsPage.endpointsInventory')}
            />

            <AdminContentCard
                title={t('adminEndpointsPage.usedEndpoints')}
                description={t('adminEndpointsPage.consumedDescription')}
            >
                <div className="adminTableWrap">
                    <table className="adminTable">
                        <thead>
                        <tr>
                            <th>{t('adminEndpointsPage.method')}</th>
                            <th>{t('adminEndpointsPage.route')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {ENDPOINTS_USED.map((item: { method: string; path: string }) => (
                            <tr key={`${item.method}:${item.path}`}>
                                <td>
                                    <code>{item.method}</code>
                                </td>
                                <td>
                                    <code>{item.path}</code>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </AdminContentCard>
        </div>
    );
}
